import React, { useContext } from "react";
import {
	useFormContext,
	Controller,
	ControllerRenderProps,
} from "react-hook-form";

import { DatePickerFromTo, DatePickerWithLoaderWrapper } from "components";
import { FilterColumnDateProps } from "types";

import FiltersContext from "../filtersContext";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumnDateProps;
};

const FilterDatePickerFromTo = ({ column }: FilterColumnProps) => {
	const { loading } = useContext(FiltersContext);
	const { control, setValue } = useFormContext();

	return (
		<Controller
			control={control}
			name={column.name || ""}
			defaultValue={null}
			render={({ field }: { field: ControllerRenderProps }) => (
				<DatePickerWithLoaderWrapper
					input={field}
					isLoading={!!loading}
					renderDatePicker={input => (
						<DatePickerFromTo
							value={input?.value}
							onChange={value => {
								setValue(input?.name || "", value);
							}}
							placeholderText={column.placeholder}
							wrapperClassName={styles.column}
							connectDatePickerFn={column.connectDatePickerFn}
							connectionName={column.connectionName}
							minDate={column.minDate}
							maxDate={column.maxDate}
						/>
					)}
				/>
			)}
		/>
	);
};

export default FilterDatePickerFromTo;
